<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs v-model="tab">
        <b-tab :title="$t('quran_programs.quran_programs')">
          <data-table :edit-item="editItem" />
        </b-tab>
        <b-tab
          @click="newItem = { recorded: 0, attendance: 0,camera:0, draft: 1 }"
          :title="$t('site.add')"
          v-if="$role == 'super_admin'||$role == 'QuranAdmin'"
        >
          <my-form :new-item="newItem" />
        </b-tab>
      </b-tabs>
    </div>
    <!-- end of card body -->
    <!-- end of card -->
    <!-- end of col -->
  </div>
</template>

<script>
import DataTableVue from "./components/DataTable.vue";
import FormVue from "./components/AddWizard.vue";

export default {
  name: "QuranProgramsIndex",
  components: {
    "data-table": DataTableVue,
    "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
    };
  },
  methods: {
    editItem(data) {
      this.newItem = data.item;
      this.tab = 1;
    },
  },
};
</script>
